module.exports = {
    period: 'DAY',
    region: 'SWEDEN',
    market: 'SSE',
    list: 'SSE_ALL',
    sort: {
        column: 'LONG_NAME',
        direction: 'DESC',
    },
};



/** WEBPACK FOOTER **
 ** /config/filters.js
 **/